import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=606ea25a&scoped=true"
import script from "./ArticleInfo.vue?vue&type=script&lang=js"
export * from "./ArticleInfo.vue?vue&type=script&lang=js"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=606ea25a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ea25a",
  null
  
)

export default component.exports